import React from 'react'
import { createPortal } from 'react-dom'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { List, ListItem } from '@mobi/component-library/Base/List'
import { colors } from '@mobi/component-library/Foundations'
import { Tray } from '@mobi/component-library/Overlays/Tray'
import { trackBetLoopSortFeed } from '@core/Areas/BetLoop/helpers/analytics'
import type { SortFilter, SortOrder } from '@core/Areas/BetLoop/types'
import { SortButtonBar } from './Components/SortButtonBar'
import type { SortOption } from './types'

const sortFeedOptions: SortOption[] = [
  { label: 'Next Up', filter: 'JumpTime', order: 'sortAsc' },
  { label: 'Number of Copies', filter: 'Copies', order: 'sortDesc' },
  { label: 'Time Posted (Newest)', filter: 'ShareTime', order: 'sortDesc' },
  { label: 'Time Posted (Oldest)', filter: 'ShareTime', order: 'sortAsc' },
  { label: 'Highest Fixed Odds', filter: 'Odds', order: 'sortDesc' },
  { label: 'Lowest Fixed Odds', filter: 'Odds', order: 'sortAsc' },
]

export const SortFeed: React.FC<{
  sortOrder: SortOrder
  sortFilter: SortFilter
  handleSortOrderChange(order: SortOrder): void
  handleSortFilterChange(filter: SortFilter): void
}> = ({ sortFilter, sortOrder, handleSortFilterChange, handleSortOrderChange }) => {
  const [isSortTrayOpen, setIsSortTrayOpen] = React.useState(false)

  const selectedOption = getSelectedSortOptionLabel(sortOrder, sortFilter)

  const onSelectSortOption = (option: SortOption) => () => {
    const selected = sortFeedOptions.find(x => x.label === option.label)
    if (!selected) return

    handleSortOrderChange(option.order)
    handleSortFilterChange(option.filter)
    setIsSortTrayOpen(false)
    trackBetLoopSortFeed(option.label)
  }

  return (
    <>
      <SortButtonBar onClick={() => setIsSortTrayOpen(true)} label={selectedOption} />

      {createPortal(
        <Tray
          isOpen={isSortTrayOpen}
          headerTitle='Sort By'
          onDismiss={() => setIsSortTrayOpen(false)}
        >
          <List shouldUseInlinePadding={false} bottomBorder='none'>
            {sortFeedOptions.map(option => {
              const isSelected = option.label === selectedOption

              return (
                <ListItem
                  onClick={onSelectSortOption(option)}
                  key={option.label}
                  text={option.label}
                  contentRight={
                    isSelected ? (
                      <Icon name='LineCheck' size='1.8rem' color={colors.lavender['700']} />
                    ) : null
                  }
                />
              )
            })}
          </List>
        </Tray>,
        document.body
      )}
    </>
  )
}

// =============
// Local Helpers
// =============

const getSelectedSortOptionLabel = (order: SortOrder, filter: SortFilter) => {
  const label = sortFeedOptions.find(option => option.order === order && option.filter === filter)
  return label?.label ?? sortFeedOptions[0].label
}
